module.exports = __webpack_public_path__ + "static/media/apple_icon.2928664f.svg";